const getters = {
  isLogin: state => state.user.isLogin,
  user: state => state.user.user,
  location: state => state.user.location,
  cartNum: state => state.user.cartNum,
  currencyarea: state => state.user.currencyarea,
  unit: state => state.user.unit,
  config: state => state.user.config
}

export default getters
